import { version } from "react";
import { environment } from "../../config";
import {
  CreditosMensualesOrg,
  CreditosMensualesSuborg,
  CreditosMensualesSuscrip,
  CreditosMensualesUser,
  CreditosUsario,
  InfoCredits,
} from "../../interfaces/SuperAdmin/Pages/iDataCreditos";
import {
  CreditosRequestParams,
  DashboardDataMap,
  DashboardType,
  endpointMap,
} from "../../interfaces/SuperAdmin/Pages/iDataDashboard";
import { fetchData } from "./httpClient";

const { REACT_APP_API_CONTROL_TRANSACCIONAL, VERSION } = environment;
const baseApiBroker = REACT_APP_API_CONTROL_TRANSACCIONAL;

export const getTotalCreditsByDashboardType = <T extends DashboardType>(
  type: T,
  filter: CreditosRequestParams
) => {
  const endpoint = endpointMap[type];
  const params = {
    ...Object.fromEntries(
      Object.entries(filter).filter(([_, value]) => value !== undefined)
    ),
    version: VERSION,
  };

  return fetchData<DashboardDataMap[T]>({
    method: "GET",
    url: `${baseApiBroker}/${endpoint}`,
    params,
  });
};

type ResCreditosMensuales =
  | CreditosMensualesOrg
  | CreditosMensualesSuscrip
  | CreditosMensualesSuborg
  | CreditosMensualesUser;

export const getMonthlyCreditsByType = <T extends DashboardType>(
  type: T,
  id: string,
  start_month?: string,
  months?: string
) => {
  const endpoint = endpointMap[type];
  return fetchData<ResCreditosMensuales>({
    method: "GET",
    url: `${baseApiBroker}/${endpoint}/${id}`,
    params: {
      ...(start_month && { start_month }),
      ...(months && { months }),
    },
  });
};

export const getTotalCreditosUser = (
  id_organizacion: string,
  id_suborganizacion: string | null,
  id_usuario?: string
) =>
  fetchData<CreditosUsario[]>({
    method: "GET",
    url: `${baseApiBroker}/creditos-usuario`,
    params: {
      ...(id_organizacion && { id_organizacion }),
      ...(id_suborganizacion && { id_suborganizacion }),
      ...(id_usuario && { id_usuario }),
    },
  });

export const getInfoCredits = (id_usuario: string) =>
  fetchData<InfoCredits>({
    method: "GET",
    url: `${baseApiBroker}/info-creditos`,
    params: { id_usuario },
  });
